import { Row, Col, Button } from "antd";
import Modal from "antd/lib/modal/Modal";
import React from "react";

const DeleteConfirmModal = (props) => {


  const onCancel = () => {
    if(props.onNo) props.onNo();
    props.hideModal(false);
    props.deleteStatus(false)
  };

  const ConfirmDelete = () => {
    if(props.onYes) props.onYes();
    props.hideModal(false);
    props.deleteStatus(true);
  }

  return (
    <>
      <Modal
        visible={props?.visible}
        centered
        onCancel={onCancel}
        closable={false}
        footer={false}
        maskClosable={false}
        enforceFocus={false}
        width={600}
        style={{ top: 20 }}
        bodyStyle={{ padding: '10px', borderRadius: '2px' }}
      >
        <div style={{
            borderBottom: '1px solid #BFBFBF',
            borderRadius: "2px 2px 0px 0px",
            width: "auto",
            margin: "-14px",
            color: "#333333",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding:"13px 16px"
          }}
        >
          <div style={{ fontSize: '16px', fontWeight: '700', color:'#474747', margin: 0 }}>{props?.titleText}</div>
          <div style={{ cursor: 'pointer', fontSize: '20px', color: '#474747', lineHeight: 1, padding: '2px 6px' }} onClick={onCancel}>x</div>
        </div>

        <p className="fs-5 d-flex justify-content-center" style={{ color: "#333333", textAlign: "left", paddingTop:"35px", paddingBottom:"10px", fontSize:"16px"}}>
          {props?.bodyContent}
        </p>

        <Row className="justify-content-center mb-3">

          <Col className="me-3">
            <Button
              style={{
                backgroundColor: "white",
                color: "#720C20",
                border: "1px solid #720c20",
                height:"44px",
                minWidth:"90px"
              }}
              onClick={onCancel}
            >
              No
            </Button>
          </Col>
          <Col className="">
            <Button
              style={{
                backgroundColor: "#720c20",
                color: "white",
                border: "none",
                height:"44px",
                minWidth:"90px"
              }}

              onClick={()=>ConfirmDelete()}
            >
              {props.yesButtonText || "Yes"}
            </Button>
          </Col>
        </Row>
      </Modal>


    </>
  );
};

export default DeleteConfirmModal;
